import { render, staticRenderFns } from "./ProductDetailsPage.vue?vue&type=template&id=6a7232ca&scoped=true&"
import script from "./ProductDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailsPage.vue?vue&type=style&index=0&id=6a7232ca&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7232ca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BreadCrumbs: require('/var/www/pb-store/components/BreadCrumbs.vue').default,SlideShow: require('/var/www/pb-store/components/SlideShow.vue').default,AttributesCheckbox: require('/var/www/pb-store/components/AttributesCheckbox.vue').default,ModalProducts: require('/var/www/pb-store/components/ModalProducts.vue').default})
